import { createSelector } from "reselect";
import get from "lodash.get";
import { createPolicyForInternalNameSelector } from "src/selectors/data_selectors";

//Constants
import { policyInternalNames } from "src/constants";

/**
 * Memoized selector to determine if janssen dashboard is enabled for dashboard
 */

export const janssenDashboardEnabledSelector = createSelector(
  createPolicyForInternalNameSelector(
    policyInternalNames.janssenDashboardEnabled
  ),
  policy => {
    return get(policy, "attributes.policyValue", false);
  }
);
